import { Component, inject } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ShopOrderRefundResponse } from 'src/app/connect-api/api/shop/shop-order.service';

@Component({
  selector: 'app-shop-order-refund-result-modal',
  templateUrl: './shop-order-refund-result-modal.component.html',
  styleUrl: './shop-order-refund-result-modal.component.scss'
})
export class ShopOrderRefundResultModalComponent {
  response: ShopOrderRefundResponse =
    inject(DynamicDialogConfig).data.response;
  ref = inject(DynamicDialogRef);

  get hasNewOrder(): boolean {
    return !!(this.response.orderId && this.response.orderNumber);
  }

  get showRefundResultMessage(): boolean {
    return this.response.refund != null && this.response.refundStatus !== 'processing';
  }

  get isRefundProcessing(): boolean {
    return this.response.refundStatus === 'processing';
  }

  get cancellationMessage(): string {
    return this.hasNewOrder
      ? 'O cancelamento foi feito com sucesso e foi criado uma nova order com itens remanescentes.'
      : 'Cancelamento realizado com sucesso.';
  }

  get refundMessage(): string {
    return this.response.refund
      ? 'O estorno foi realizado com sucesso!'
      : 'Não foi possível fazer o estorno, por favor realize o mesmo de forma manual.';
  }

  get refundProcessingMessage(): string {
    return 'Estorno em processamento, por favor aguarde alguns intantes a atualização da order ou verifique junto ao gateway de pagamento';
  }

  goToNewOrder(): void {
    this.ref.close();
    window.location.assign(`/shop-orders/order/${this.response.orderId}`);
  }

  close(): void {
    this.ref.close();
  }
}
